exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".confirm-phrase-input[data-v-6a337804] {\n  max-width: 360px;\n  width: 100%;\n}", ""]);

// exports
